import { useRemoteClientDelete } from '../../../../../configs/http-client'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const deleteTemplate = async (id: string | number, reloadTemplates: () => void) => {
  const { getUnitId } = useLocalStorage()
  const { remoteClientDelete } = useRemoteClientDelete()
  const { showToast } = useToast()
  try {
    await remoteClientDelete('/contratos', id + `?idUnidade=${getUnitId()}`)
    reloadTemplates()
    showToast('Template deletado', 'success')
  } catch (error) {
    console.error(error)
    showToast('Erro ao deletar o template', 'error')
  }
}
